import { message } from "antd";
import jsPDF from "jspdf";

const LOGO_WARNING_KEY = "company-logo-missing";

export const logoAspectRatio = (image: HTMLImageElement): number =>
  image.naturalHeight > 0 ? image.naturalWidth / image.naturalHeight : 1;

export const loadCompanyLogo = (
  companyLogo?: string | null,
): Promise<HTMLImageElement | null> =>
  new Promise(resolve => {
    if (!companyLogo) {
      message.warning({
        content:
          "Company logo is missing in Company Info. Please add a company logo in Company Info to display it on documents.",
        key: LOGO_WARNING_KEY,
      });
      return resolve(null);
    }
    const image = new Image();
    let settled = false;
    const finish = (result: HTMLImageElement | null) => {
      if (!settled) {
        settled = true;
        resolve(result);
      }
    };
    const timeout = setTimeout(() => finish(null), 10000);
    image.onload = () => {
      clearTimeout(timeout);
      finish(image.naturalWidth > 0 ? image : null);
    };
    image.onerror = () => {
      clearTimeout(timeout);
      finish(null);
    };
    image.src = companyLogo;
  });

export const placeCompanyLogo = async (
  doc: jsPDF,
  companyLogo: string | null | undefined,
  _companyName: string | undefined,
  layout: { x: number; y: number; width: number; height?: number },
) => {
  const image = await loadCompanyLogo(companyLogo);
  if (image) {
    const height = layout.height ?? layout.width / logoAspectRatio(image);
    doc.addImage(
      image,
      "png",
      layout.x,
      layout.y,
      layout.width,
      height,
      "logo",
      "FAST",
    );
    return;
  }
};
